import { NextPage } from 'next'
import { AppProps } from 'next/app'
import Head from 'next/head'
import { Fragment } from 'react'

import { ReactDevTools } from 'utils'

import { Amplify } from 'aws-amplify'
import { configure } from 'web-amplify/configure'

import { Provider } from 'web/Provider'

import 'overlayscrollbars/overlayscrollbars.css'
import 'promise-tracker/src/assets/styles/nprogress.css'
import 'simplebar-react/dist/simplebar.min.css'
import 'swiper/css'

import '../styles/globals.css'
import './index.css'

Amplify.configure(configure, {
  ssr: true
})

/**
 * Enable or disable React Dev Tools
 * based on NODE_ENV or ENABLE_REACT_DEV_TOOLS
 */
ReactDevTools.init()

interface CustomAppProps extends AppProps {
  Component: NextPage
}

const App = ({ Component, pageProps }: CustomAppProps) => {
  return (
    <Fragment>
      <Head>
        <meta
          name='viewport'
          content='initial-scale=1, viewport-fit=cover, width=device-width, user-scalable=no'
        />
        <meta
          name='apple-mobile-web-app-capable'
          content='yes'
        />
        <meta
          name='apple-mobile-web-app-status-bar-style'
          content='black-translucent'
        />
      </Head>

      <Provider
        ssr={pageProps?.ssr}
        dehydratedState={pageProps?.dehydratedState}
        authState={pageProps?.authState}
      >
        <Component {...pageProps} />
      </Provider>
    </Fragment>
  )
}

export default App
